import { Kettle } from '@execonline-inc/kettle.private';
import { observer } from 'mobx-react';
import * as React from 'react';
import { LectureSegment } from '../../../../LectureStore/Types';
import CurrentSlidePpt from './CurrentSlidePpt';

interface Props {
  segment: LectureSegment;
  kettle: Kettle;
  refWrapperEl: React.RefObject<HTMLDivElement | null>;
  pptRefEl: React.RefObject<HTMLIFrameElement | null>;
  pptSizerEl: React.RefObject<HTMLDivElement | null>;
}

@observer
class CurrentSlide extends React.Component<Props, {}> {
  render() {
    const { segment, kettle, pptRefEl, refWrapperEl, pptSizerEl } = this.props;
    return (
      <CurrentSlidePpt
        segment={segment}
        kettle={kettle}
        refEl={pptRefEl}
        refWrapperEl={refWrapperEl}
        pptSizerEl={pptSizerEl}
      />
    );
  }
}

export default CurrentSlide;
